/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Text } from '~components/Typography';

const TableToolbar = (props: unknown): React.ReactElement => {
  return <Text>Table Component is not available for Native mobile apps.</Text>;
};

const TableToolbarActions = (props: unknown): React.ReactElement => {
  return <Text>Table Component is not available for Native mobile apps.</Text>;
};

export { TableToolbar, TableToolbarActions };
